export default __webpack_public_path__ + "static/media/brokenVase.5875cc37.jpg";